// extracted by mini-css-extract-plugin
export default {"root":"X5GWe28XCI","thumbnail":"RbEQqIWzIY","stats":"TcKX5jnyoi"};